import { z } from 'zod';
/**
 * Schema for user sign-up
 */
export const signUpSchema = z.object({
    email: z.string().email('Invalid email format'),
    password: z
        .string()
        .min(8, 'Password must be at least 8 characters')
        .max(100, 'Password too long')
        .regex(/[A-Z]/, 'Password must contain at least one uppercase letter')
        .regex(/[a-z]/, 'Password must contain at least one lowercase letter')
        .regex(/[0-9]/, 'Password must contain at least one number')
        .regex(/[^A-Za-z0-9]/, 'Password must contain at least one special character'),
    name: z
        .string()
        .min(2, 'Name must be at least 2 characters')
        .max(100, 'Name too long'),
});
//# sourceMappingURL=sign-up.schema.js.map